import { render, staticRenderFns } from "./RheumatologyIcon.vue?vue&type=template&id=52595eff&scoped=true&"
import script from "./RheumatologyIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RheumatologyIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52595eff",
  null
  
)

export default component.exports